import { Accountant, accountantReducer } from "./accountantReducers";
import { IActivityLog, activityLogReducer } from "./activityLogReducers";
import { IClient, clientReducer } from "./clientReducers";
import { IConditions, conditionsReducer } from "./conditionsReducers";
import {
  ICountryAndProvincesInfo,
  countryAndProvincesInfoReducer,
} from "./countryAndProvincesInfoReducers";
import {
  IDashboardApisData,
  dashboardApisDataReducer,
} from "./dashboardApisDataReducers";
import { IDrawer, drawerReducer } from "./drawerReducer";
import { IDrawerMenu, drawerMenuReducer } from "./drawerMenuReducers";
import { IHomePage, homePageReducer } from "./homePageReducers";
import { IInvoiceReport, invoiceReportReducer } from "./invoiceReportReducers";
import {
  IIsLoadAxiosCall,
  isLoadAxiosCallReducer,
} from "./isLoadAxiosCallReducers";
import { INavigation, navigationReducer } from "./navigationReducers";
import {
  IPayrollFilters,
  payrollFiltersReducer,
} from "./payrollFiltersReducers";
import { ISlips, slipsReducer } from "./slipsReducers";
import { IStickyNavBar, stickyNavBarReducer } from "./stickyNavBarReducers";
import {
  ITransactionsHeaders,
  transactionsHeadersReducer,
} from "./transactionsHeadersReducers";

import { ComponentState } from "../../common/enums";
import { ICSVInformationUI } from "./CSVInformationUIReducer";
import { ITaxYear } from "./taxYearReducers";
import { IUserProfile } from "../../models/IUserProfile";
import { combineReducers } from "redux";
import { drawerMenuOptionsReducer } from "./drawerMenuOptionsReducers";
import loginReducer from "./loginReducers";
import { taxYearReducer } from "./taxYearReducers";
import { viewStateReducer } from "./viewStateReducer";

export interface IAppState {
  user: {
    profile: IUserProfile;
    isAuthenticated: boolean;
    token: string;
  };
  viewState: {
    loading: boolean;
    error: boolean;
    success: boolean;
    message: string;
    componentState: ComponentState;
  };
  accountant: Accountant;
  client: IClient;
  HomePagePath: IHomePage;
  drawerAction: IDrawer;
  stickyNavBar: IStickyNavBar;
  activityLog: IActivityLog;
  navigation: INavigation;
  taxYear: ITaxYear;
  countryAndProvincesInfo: ICountryAndProvincesInfo;
  drawerMenu: IDrawerMenu;
  drawerMenuOptions: IDrawerMenu;
  invoice: IInvoiceReport;
  CSVInformationUI: ICSVInformationUI;
  //   HomePagePath: IHomePage;
  //   drawerAction: IDrawer;
  //   activityLog: IActivityLog;
  isLoadAxiosCall: IIsLoadAxiosCall;
  //   resourceApiMessage: IResourceApiMessage;
  //   stickyNavBar: IStickyNavBar;
  dashboardApisData: IDashboardApisData;
  transactionsHeaders: ITransactionsHeaders;
  payrollFilters: IPayrollFilters;
  conditions: IConditions;
  slips: ISlips;
}

const rootReducer = combineReducers({
  user: loginReducer,
  viewState: viewStateReducer,
  accountant: accountantReducer,
  client: clientReducer,
  navigation: navigationReducer,
  taxYear: taxYearReducer,
  countryAndProvincesInfo: countryAndProvincesInfoReducer,
  drawerMenu: drawerMenuReducer,
  drawerMenuOptions: drawerMenuOptionsReducer,
  invoice: invoiceReportReducer,
  //   CSVInformationUI: CSVInformationUIReducer,
  HomePagePath: homePageReducer,
  drawerAction: drawerReducer,
  activityLog: activityLogReducer,
  isLoadAxiosCall: isLoadAxiosCallReducer,
  //   resourceApiMessage: resourceApiMessageReducer,
  stickyNavBar: stickyNavBarReducer,
  dashboardApisData: dashboardApisDataReducer,
  transactionsHeaders: transactionsHeadersReducer,
  payrollFilters: payrollFiltersReducer,
  conditions: conditionsReducer,
  slips: slipsReducer,
});

// Define the RootState type based on the result of combineReducers
// export type RootState = ReturnType<typeof rootReducer>;
export type RootState = IAppState;

export default rootReducer;
